
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  RuleConditionDefinition, RuleCustomValue, RuleLogCondition, RuleLogNode,
} from '@/types';
import { conditionValues, nodeLabel } from '@/helpers/ruleLogHelpers';
import RuleCustomValueDisplay from './RuleCustomValueDisplay.vue';

@Component({ name: 'RuleLogConditionTree', components: { RuleCustomValueDisplay } })
export default class RuleLogConditionTree extends Vue {
  @Prop({ type: Array, required: true }) readonly nodes!: RuleLogNode[];

  get definitions(): RuleConditionDefinition[] {
    return this.$store.getters.ruleConditionDefinitions || [];
  }

  label(node: RuleLogNode): string {
    return nodeLabel(node, this.definitions);
  }

  values(node: RuleLogCondition): RuleCustomValue[] {
    return conditionValues(node, this.definitions);
  }

  icon(node: RuleLogNode): string {
    if (node.type === 'condition' && node.error) return 'mdi-alert-circle';
    if (node.result === true) return 'mdi-check-circle';
    if (node.result === false) return 'mdi-close-circle';
    return 'mdi-help-circle-outline';
  }

  color(node: RuleLogNode): string {
    if (node.type === 'condition' && node.error) return 'error';
    if (node.result === true) return 'statusDone';
    if (node.result === false) return 'error';
    return 'grey';
  }
}
